<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  TreatmentWizard(
    v-show="!isSubmitting",
    :data="treatmentData",
    :on-save-draft="saveDraft",
    @submit="create"
  )
</template>

<script>
import TreatmentWizard from '../shared/TreatmentWizard.vue'
import useTreatmentAdd from './useTreatmentAdd'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    TreatmentWizard,
    Loading,
  },
  setup() {
    const { create, saveDraft, treatmentData, isSubmitting } = useTreatmentAdd()

    return {
      create,
      saveDraft,
      treatmentData,
      isSubmitting,
    }
  },
}
</script>
